import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import styled from 'styled-components';

import { ColumnBlock } from '../../layout/components';
import { PageContainer } from '../../content/components';

import find from 'lodash/find';
import findIndex from 'lodash/findIndex';

import * as peopleActions from '../people.actions';
import { getPeopleByDisciplineFlat } from '../people.selectors';

import { Bio, BioNavButton } from './';
import styles from '../../../styles';


const Fade = ({ children, ...props }) => (
  <CSSTransition {...props} timeout={1500} classNames={{
    enter: 'test-enter',
    enterActive: 'test-enter-active',
    exit: 'fade-exit',
    exitActive: 'fade-exit-active',
  }}>
    {children}
  </CSSTransition>
);

const NavBlock = styled(ColumnBlock)`
  flex-direction: row;
  &.prev {
    justify-content: flex-start;
  }
  &.next {
    justify-content: flex-end;
  }
  a {
    margin-bottom: 0 !important;
  }
`;

const Blocker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform-origin: 100% 50%;
  transform: translate3d(-100%,0,0);
  background: white;
`;

const StyledPageContainer = styled(PageContainer)`
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  
  &.test-enter {
    opacity: 0.01;
  }
  
  &.test-enter.test-enter-active {
    opacity: 1;
    transition: opacity 1000ms ${styles.easing.inOutCubic};
    transition-delay: 500ms;
  }
  
  &.fade-exit {
    z-index: 100;
    opacity: 1;
    ${Blocker} {
      transform: translate3d(-100, 0, 0);
      opacity: 1;
    }
  }
  &.fade-exit.fade-exit-active {
    opacity: 0.01;
    transition: opacity 500ms ${styles.easing.inOutCubic};
    transition-delay: 500ms;
    pointer-events: none;

    ${Blocker} {
      transform: translate3d(0, 0, 0);
      transition: transform 0.5s ${styles.easing.inOutCubic};
    }
  }
  

`;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
`;

class BioBrowser extends Component {
  componentDidMount = () => {
    const { readPeople, people } = this.props;
    if (!people || people.length === 0) {
      readPeople();
    }
  };

  render() {
    const { breakpoint, current, prev, next } = this.props;

    if (!current) return null;

    const nextLink = next && `/team/${next.slug}`;
    const prevLink = prev && `/team/${prev.slug}`;

    return (
      <TransitionGroup component={React.Fragment}>
        <Fade key={current.slug} unmountOnExit>
          <StyledPageContainer>
            <StyledContainer>
              {breakpoint !== 'phone' && (
                <NavBlock columns={1} className="prev">
                  {prev && <BioNavButton data={prev} to={prevLink} isPrev />}
                </NavBlock>
              )}
              <ColumnBlock columns={2}>
                <Bio breakpoint={breakpoint} person={current} />
              </ColumnBlock>
              {breakpoint !== 'phone' && (
                <NavBlock columns={1} className="next">
                  {next && <BioNavButton data={next} to={nextLink} />}
                </NavBlock>
              )}
            </StyledContainer>
            <Blocker />
          </StyledPageContainer>
        </Fade>
      </TransitionGroup>
    );
  }
}

BioBrowser.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  people: PropTypes.array,
  current: PropTypes.object,
  next: PropTypes.object,
  prev: PropTypes.object,
  readPeople: PropTypes.func.isRequired,
};

BioBrowser.defaultProps = {};

const mapStateToProps = (state, { match }) => {
  const { breakpoint } = state.layout;
  const { params: { person } } = match;
  const { byId, browser: { ids } } = state.entities.people;
  const people =
    (ids.length && ids.map(id => byId[id])) || getPeopleByDisciplineFlat(state);
  const current = find(people, { slug: person });
  const index = findIndex(people, { slug: person });
  const prev = index > 0 ? people[index - 1] : people[people.length - 1];
  const next = index < people.length - 1 ? people[index + 1] : people[0];

  return {
    breakpoint,
    current,
    prev,
    next,
  };
};

export default withRouter(connect(mapStateToProps, peopleActions)(BioBrowser));



// WEBPACK FOOTER //
// ./src/modules/people/components/BioBrowser.js